// src/presentation/component/Searchbar.tsx
import React from "react";
import { useSearch } from "../context/SearchContext";

const Searchbar: React.FC = () => {
  const { searchQuery, setSearchQuery } = useSearch();

  return (
    <input
      type="text"
      placeholder="Search"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      className="px-4 py-2 border rounded-full w-80 focus:outline-none bg-gray-100"
    />
  )
}

export default Searchbar